import React from 'react'
import { Dialog, DialogAppendToType } from 'primereact/dialog'
import { PropsType } from '../../../models/util'
import { useWindowResize } from '../../../utils/hooks'
import FormInput from '../../form/FormInput'
import LuxButton from '../../buttons/Button'
import Heading from '../../text/Heading'
import Text from '../../text/Text'
import InputWrapper from '../../form/form-inputs/InputWrapper'
import { INPUT_TYPE } from '../../../models/form'

export interface LuxDialogProps extends PropsType {
    formFields: {
        value?: any
        type?: INPUT_TYPE
        onChangeCallback?: (e: any) => void
        classes?: string
        containerClasses?: string
        style?: any
        optionsList?: any[]
        filterable?: boolean
        selectAllLabel?: boolean
        mandatory?: boolean
        clearable?: boolean
        disabled?: boolean
        colWidth?: number | string
        label?: string
        floatingLabel?: boolean
        placeholder?: string
        maxDate?: Date
        minDate?: Date
        maxStartDate?: Date
        minEndDate?: Date
        firstDayOfWeek?: number
        onRemoveChip?: (e: any) => void
        additionalProps?: any
        editable?: boolean
        itemTemplate?: any
        panelClassName?: string
    }[]
    visible: boolean
    onHide: () => void
    onShow?: () => void
    onSubmit: (args?: any) => void
    blockScroll?: boolean
    header?: React.ReactNode
    footer?: React.ReactNode
    body?: string
    additionalActions?: any
    appendTo?: DialogAppendToType
    baseZIndex?: number
    resizable?: boolean
    icon?: string
    clearformFields?: any
    labels?: {
        formTitle?: string
        submit?: string
        cancel?: string
    }
    classes?: string
    disableSubmit?: boolean
    hideButtons?: boolean
    hideCancelButton?: boolean
}

export const FormDialog = (props: LuxDialogProps) => {
    const isMobile = useWindowResize()

    return (
        <Dialog
            {...props}
            header={
                <Heading type="h1" classes="flex p-align-center">
                    {props.icon ? (
                        <i className={`p-mr-2 ${props.icon}`}></i>
                    ) : (
                        <></>
                    )}
                    {props.labels?.formTitle}
                </Heading>
            }
            footer={
                !props?.hideButtons ? (
                    <div
                        className={`p-d-flex p-jc-end ${
                            isMobile ? 'p-col-12 p-dir-col-rev' : ''
                        }`}>
                        {!props?.hideCancelButton && (
                            <LuxButton
                                classes={isMobile ? 'p-col-12' : ''}
                                text={
                                    props.labels?.cancel
                                        ? props.labels.cancel
                                        : 'Cancel'
                                }
                                variant={['secondary', 'outlined']}
                                onClick={() => props.onHide()}
                            />
                        )}
                        {props.additionalActions?.length &&
                            props.additionalActions.map((f, i) => (
                                <LuxButton
                                    key={i}
                                    classes={isMobile ? 'p-col-12' : ''}
                                    text={f.text}
                                    variant={f.variant}
                                />
                            ))}

                        <LuxButton
                            classes={isMobile ? 'p-col-12' : ''}
                            text={
                                props.labels?.submit
                                    ? props.labels.submit
                                    : 'Submit'
                            }
                            variant={['primary']}
                            onClick={() => {
                                props.onHide()
                                props.onSubmit()
                            }}
                            disabled={
                                props.disableSubmit
                                    ? props.disableSubmit
                                    : false
                            }
                        />
                    </div>
                ) : (
                    <div></div>
                )
            }
            className={`wardrobe-form-dialog p-d-flex p-p-0 p-jc-center p-col-12 p-md-10 p-lg-8 p-xl-6 ${
                props.classes ? props.classes : ''
            }`}
            baseZIndex={props.baseZIndex ? props.baseZIndex : 1220}>
            {props.body && <Text classes="p-col-12">{props.body} </Text>}
            <div className="p-pb-2 p-grid">
                {props.formFields?.length &&
                    props.formFields.map((f, i) => (
                        <InputWrapper
                            key={i}
                            type={f.type}
                            value={f.value}
                            label={f.label}
                            classes={f.classes}
                            containerClasses={f.containerClasses}
                            clearable={f.clearable}
                            placeholder={f.placeholder}
                            disabled={
                                (f.editable !== undefined && !f.editable) ||
                                f.disabled
                            }
                            additionalProps={f.additionalProps}
                            onChangeCallback={f.onChangeCallback}
                            colWidth={f.colWidth ? f.colWidth : 12}
                            optionsList={f.optionsList}
                            filterable={f.filterable ? f.filterable : false}
                            itemTemplate={f.itemTemplate}
                            panelClassName={f.panelClassName}
                        />
                    ))}
            </div>
        </Dialog>
    )
}
